export default __webpack_public_path__ + "static/media/responsible.1243ffad.svg";